import { FileWithPath } from "@mantine/dropzone";

import { useCompany } from "#modules/company/view/useCompany";
import { useCompanyModelType } from "#modules/company/view/useCompanyModelType";
import { getPartsFromFiles } from "#modules/parts/domain/getPartsFromFiles";
import { useCreatePart } from "#modules/parts/view/useCreatePart";
import { useCreateQuoteRequest } from "#modules/quoteRequests/view/useCreateQuoteRequest";
import { AssemblySplitModeSchema, PredictionModelTypeSchema } from "shared";

export const usePredictParts = ({
  onSuccess,
  quoteRequestId,
  currentQuoteRequestLineIndex,
}: {
  onSuccess: (quoterequestId: string) => void;
  quoteRequestId?: string;
  currentQuoteRequestLineIndex: number;
}) => {
  const { createQuoteRequest } = useCreateQuoteRequest();
  const { createPartAsync, progress, isPending } = useCreatePart({});

  const modelType = useCompanyModelType();
  const { company } = useCompany();

  const onDropFile = async (files: FileWithPath[]) => {
    let currentQuoteRequestId: string | undefined | null = quoteRequestId;

    if (!currentQuoteRequestId) {
      const quoteRequest = await createQuoteRequest();

      if (!quoteRequest) {
        throw new Error("No quote request found");
      }

      currentQuoteRequestId = quoteRequest.id;
    }

    const partsFromFiles = await getPartsFromFiles(files);

    const createPartsPromises = partsFromFiles.map((partData, index) =>
      createPartAsync({
        data: {
          ...partData,
          quoteRequestId: currentQuoteRequestId,
          index: currentQuoteRequestLineIndex + index,
          assemblySplitMode:
            company?.companySettings.assemblySplitMode === "ALL"
              ? AssemblySplitModeSchema.enum.LEAF
              : company?.companySettings.assemblySplitMode || AssemblySplitModeSchema.enum.LEAF,
          computeEmbeddings: false,
          computeTopologicalEmbedding: true,
          computeGraphs: modelType !== PredictionModelTypeSchema.enum.CLUSTERING,
          shouldCreateQuoteRequestLine: true,
        },
      }),
    );

    await Promise.allSettled(createPartsPromises);

    onSuccess(currentQuoteRequestId);
  };

  return { onDropFile, progress, isPending };
};
